"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "A11y", {
  enumerable: true,
  get: function get() {
    return _a11y.default;
  }
});
Object.defineProperty(exports, "Autoplay", {
  enumerable: true,
  get: function get() {
    return _autoplay.default;
  }
});
Object.defineProperty(exports, "Controller", {
  enumerable: true,
  get: function get() {
    return _controller.default;
  }
});
Object.defineProperty(exports, "EffectCards", {
  enumerable: true,
  get: function get() {
    return _effectCards.default;
  }
});
Object.defineProperty(exports, "EffectCoverflow", {
  enumerable: true,
  get: function get() {
    return _effectCoverflow.default;
  }
});
Object.defineProperty(exports, "EffectCreative", {
  enumerable: true,
  get: function get() {
    return _effectCreative.default;
  }
});
Object.defineProperty(exports, "EffectCube", {
  enumerable: true,
  get: function get() {
    return _effectCube.default;
  }
});
Object.defineProperty(exports, "EffectFade", {
  enumerable: true,
  get: function get() {
    return _effectFade.default;
  }
});
Object.defineProperty(exports, "EffectFlip", {
  enumerable: true,
  get: function get() {
    return _effectFlip.default;
  }
});
Object.defineProperty(exports, "FreeMode", {
  enumerable: true,
  get: function get() {
    return _freeMode.default;
  }
});
Object.defineProperty(exports, "Grid", {
  enumerable: true,
  get: function get() {
    return _grid.default;
  }
});
Object.defineProperty(exports, "HashNavigation", {
  enumerable: true,
  get: function get() {
    return _hashNavigation.default;
  }
});
Object.defineProperty(exports, "History", {
  enumerable: true,
  get: function get() {
    return _history.default;
  }
});
Object.defineProperty(exports, "Keyboard", {
  enumerable: true,
  get: function get() {
    return _keyboard.default;
  }
});
Object.defineProperty(exports, "Lazy", {
  enumerable: true,
  get: function get() {
    return _lazy.default;
  }
});
Object.defineProperty(exports, "Manipulation", {
  enumerable: true,
  get: function get() {
    return _manipulation.default;
  }
});
Object.defineProperty(exports, "Mousewheel", {
  enumerable: true,
  get: function get() {
    return _mousewheel.default;
  }
});
Object.defineProperty(exports, "Navigation", {
  enumerable: true,
  get: function get() {
    return _navigation.default;
  }
});
Object.defineProperty(exports, "Pagination", {
  enumerable: true,
  get: function get() {
    return _pagination.default;
  }
});
Object.defineProperty(exports, "Parallax", {
  enumerable: true,
  get: function get() {
    return _parallax.default;
  }
});
Object.defineProperty(exports, "Scrollbar", {
  enumerable: true,
  get: function get() {
    return _scrollbar.default;
  }
});
Object.defineProperty(exports, "Swiper", {
  enumerable: true,
  get: function get() {
    return _core.default;
  }
});
Object.defineProperty(exports, "Thumbs", {
  enumerable: true,
  get: function get() {
    return _thumbs.default;
  }
});
Object.defineProperty(exports, "Virtual", {
  enumerable: true,
  get: function get() {
    return _virtual.default;
  }
});
Object.defineProperty(exports, "Zoom", {
  enumerable: true,
  get: function get() {
    return _zoom.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _core.default;
  }
});

var _core = _interopRequireDefault(require("./core/core.js"));

var _virtual = _interopRequireDefault(require("./modules/virtual/virtual.js"));

var _keyboard = _interopRequireDefault(require("./modules/keyboard/keyboard.js"));

var _mousewheel = _interopRequireDefault(require("./modules/mousewheel/mousewheel.js"));

var _navigation = _interopRequireDefault(require("./modules/navigation/navigation.js"));

var _pagination = _interopRequireDefault(require("./modules/pagination/pagination.js"));

var _scrollbar = _interopRequireDefault(require("./modules/scrollbar/scrollbar.js"));

var _parallax = _interopRequireDefault(require("./modules/parallax/parallax.js"));

var _zoom = _interopRequireDefault(require("./modules/zoom/zoom.js"));

var _lazy = _interopRequireDefault(require("./modules/lazy/lazy.js"));

var _controller = _interopRequireDefault(require("./modules/controller/controller.js"));

var _a11y = _interopRequireDefault(require("./modules/a11y/a11y.js"));

var _history = _interopRequireDefault(require("./modules/history/history.js"));

var _hashNavigation = _interopRequireDefault(require("./modules/hash-navigation/hash-navigation.js"));

var _autoplay = _interopRequireDefault(require("./modules/autoplay/autoplay.js"));

var _thumbs = _interopRequireDefault(require("./modules/thumbs/thumbs.js"));

var _freeMode = _interopRequireDefault(require("./modules/free-mode/free-mode.js"));

var _grid = _interopRequireDefault(require("./modules/grid/grid.js"));

var _manipulation = _interopRequireDefault(require("./modules/manipulation/manipulation.js"));

var _effectFade = _interopRequireDefault(require("./modules/effect-fade/effect-fade.js"));

var _effectCube = _interopRequireDefault(require("./modules/effect-cube/effect-cube.js"));

var _effectFlip = _interopRequireDefault(require("./modules/effect-flip/effect-flip.js"));

var _effectCoverflow = _interopRequireDefault(require("./modules/effect-coverflow/effect-coverflow.js"));

var _effectCreative = _interopRequireDefault(require("./modules/effect-creative/effect-creative.js"));

var _effectCards = _interopRequireDefault(require("./modules/effect-cards/effect-cards.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }